import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const upcomingEvents = [
  { id: 'ue-001', date: '28 Jun', day: 'Sat', title: 'Braaier Cup', category: 'special', description: 'Monthly Braaier Cup — shotgun start 07:00. All welcome.', spots: 24 },
  { id: 'ue-002', date: '11 Jul', day: 'Fri', title: 'Night Golf', category: 'special', description: 'Glow-ball Night Golf event. Tee-off from 17:30. Glow balls provided.', spots: 16 },
  { id: 'ue-003', date: '18 Jul', day: 'Fri', title: 'Corporate Golf Day', category: 'special', description: 'Quarterly corporate day. Sponsorship packages available. Full course.', spots: 0 },
  { id: 'ue-004', date: '14 Jun', day: 'Sat', title: 'Saturday Stableford', category: 'competition', description: 'Weekly members Stableford competition. Visitors welcome to enter.', spots: 8 },
];

const catColors: Record<string, string> = {
  special: 'bg-purple-light text-purple-light-foreground',
  competition: 'bg-blue-light text-blue-light-foreground',
  holiday: 'bg-red-light text-red-light-foreground',
};

export default function UpcomingEvents() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-accent font-semibold text-sm tracking-widest uppercase">What&apos;s On</span>
            <h2 className="text-3xl font-bold text-foreground mt-2">Upcoming Events</h2>
          </div>
          <Link href="/online-booking" className="text-primary font-semibold text-sm hover:text-secondary flex items-center gap-1 transition-colors">
            View full calendar
            <Icon name="ArrowRightIcon" size={16} variant="outline" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
          {upcomingEvents.map((evt) => (
            <div key={evt.id} className="card-hover bg-card border border-border rounded-xl overflow-hidden">
              <div className="gradient-primary p-4 flex items-center gap-4">
                <div className="text-center">
                  <div className="text-accent text-2xl font-extrabold leading-none font-tabular">{evt.date.split(' ')[0]}</div>
                  <div className="text-white/70 text-xs uppercase tracking-wider mt-0.5">{evt.date.split(' ')[1]}</div>
                </div>
                <div className="w-px h-10 bg-white/20" />
                <div>
                  <div className="text-white/60 text-xs uppercase tracking-wider">{evt.day}</div>
                  <div className="text-white font-semibold text-sm">{evt.title}</div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${catColors[evt.category] || 'bg-muted text-muted-foreground'}`}>
                    {evt.category === 'special' ? 'Special Event' : 'Competition'}
                  </span>
                  {evt.spots > 0 ? (
                    <span className="text-xs text-green-light-foreground font-medium">{evt.spots} spots left</span>
                  ) : (
                    <span className="text-xs text-red-light-foreground font-medium">Fully booked</span>
                  )}
                </div>
                <p className="text-muted-foreground text-sm leading-relaxed mb-4">{evt.description}</p>
                <Link
                  href="/online-booking"
                  className={`w-full text-center block py-2 rounded-lg text-sm font-semibold transition-all duration-150 ${
                    evt.spots > 0
                      ? 'btn-primary text-white' :'bg-muted text-muted-foreground cursor-not-allowed'
                  }`}
                >
                  {evt.spots > 0 ? 'Book Now' : 'Fully Booked'}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}